// // chapterReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  bookChapterList: [], // Default value
  bookChapterListItemSelected: 1, // Default value
  open1: false,
};

const chapterSlice = createSlice({
  name: 'chapter',
  initialState,
  reducers: {
    setBookChapterList(state, action) {
      state.bookChapterList = action.payload;
    },
    setBookChapterListItemSelected(state, action) {
      state.bookChapterListItemSelected = action.payload;
    },
    setOpen1(state, action) {
      state.open1 = action.payload;
    },
    reset4Chapter() {
      return initialState;
    },
  },
});

export const { setBookChapterList, setBookChapterListItemSelected, setOpen1, reset4Chapter } = chapterSlice.actions;
export default chapterSlice.reducer;

// const initialState = {
//   bookChapterList: [], // Default value
//   bookChapterListItemSelected: 1, // Default value
//   open1: false,
// };

// export default function chapterReducer(state = initialState, action) {
//   switch (action.type) {
//     case 'setBookChapterList':
//       return {
//         ...state,
//         bookChapterList: action.payload,
//       };
//     case 'setBookChapterListItemSelected':
//       return {
//         ...state,
//         bookChapterListItemSelected: action.payload,
//       };
//     case 'setOpen1':
//       return {
//         ...state,
//         open1: action.payload,
//       };      
//     case 'reset4Chapter':
//       return initialState;       
//     default:
//       return state;
//   }
// }

// export const setBookChapterList = (e) => ({
//   type: 'setBookChapterList',
//   payload: e,
// });

// export const setBookChapterListItemSelected = (e) => ({
//   type: 'setBookChapterListItemSelected',
//   payload: e,
// });

// export const setOpen1 = (e) => ({
//   type: 'setOpen1',
//   payload: e,
// });

// export const reset4Chapter  = (e) => ({
//   type: 'reset4Chapter',
//   payload: e,
// });